/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeResponse } from '../../models/me-response';

export interface AuthMe$Plain$Params {
}

export function authMe$Plain(http: HttpClient, rootUrl: string, params?: AuthMe$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MeResponse>> {
  const rb = new RequestBuilder(rootUrl, authMe$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeResponse>;
    })
  );
}

authMe$Plain.PATH = '/api/v1/auth/me';
